import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as httpClient from "../../util/httpClient";
import * as PasswordManagerUtil from "../IdentityVault/PasswordManager/passwordManagerUtil";
import * as Common from "../../util/common";
import * as PasswordManagerAction from "../../store/passwordManagerService/actions";
import { Notification } from "../common/Notification";
import { useForm } from "react-hook-form";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const EditPassword = (props: any) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [visibleEmail, setVisisbleEmail]: any = useState([]);
    const requestRequestPasswordList = () => dispatch(PasswordManagerAction.actionCreators.requestRequestPasswordList());
    const [passwordShown, setPasswordShown] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [favourite, setFavourite] = useState(false);
    const passwordRecordExtId = useSelector((state: ApplicationState) => state.passwordManagerState && state.passwordManagerState.selectedPasswordRecordExtId);
    const [strength, setPasswordStrength] = useState({ score: 0, message: "", color: "gray" });
    const [generatePasswordState, setGeneratePasswordState] = useState({ length: "30", digits: true, symbols: true, isClosed: true });
    const { t: tLang } = useTranslation();

    const { register, errors, clearErrors, handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const [passwordData, setPasswordData] = useState({
        websiteName: "",
        favorite: null,
        websiteUsername: "",
        websiteUrl: "",
        lastUpdateDate: "",
        websitePassword: "",
        notes: "",
    });

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const getPasswordData = () => {
        const requestBody = {
            RecordExtId: passwordRecordExtId,
        };
        setLoading(true);

        if (passwordRecordExtId !== "") {
            httpClient
                .sendRequest("POST", `api/securepassword/getPasswordById`, requestBody)
                .then((data) => {
                    if (data.isSuccess) {
                        updatePasswordStrength(data.websitePassword);
                        const decodedData = Common.decodeData(Common.decodeData(data));
                        setPasswordData({
                            websiteName: decodedData["websiteName"],
                            favorite: data["favorite"],
                            websiteUsername: decodedData["websiteUsername"],
                            websiteUrl: decodedData["websiteUrl"],
                            lastUpdateDate: data["lastUpdateDate"],
                            websitePassword: data["websitePassword"],
                            notes: decodedData["notes"],
                        });

                        if (data.favorite) {
                            setFavourite(true);
                        } else {
                            setFavourite(false);
                        }
                        setGeneratePasswordState({ ...generatePasswordState, length: data["websitePassword"] ? data["websitePassword"].length.toString() : "30" });
                    }
                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                });
        }
    };

    useEffect(() => {
        getPasswordData();
    }, [passwordRecordExtId]);

    const updatePasswordStrength = (password: string) => {
        const strength = PasswordManagerUtil.passwordManagerUtilFunctions.getPasswordStrength(password, tLang);
        setPasswordStrength(strength);
    };

    const submitUpdate = () => {
        updatePassword();
    };

    const toggleEmailVisibility = (item: any) => {
        if (visibleEmail.length > 0) {
            const index = visibleEmail.findIndex((element: any) => element.websiteUsername === item.websiteUsername);
            if (index >= 0) {
                visibleEmail.splice(index, 1);
                setVisisbleEmail([...visibleEmail]);
            } else {
                setVisisbleEmail([...visibleEmail, item]);
            }
        } else {
            setVisisbleEmail([...visibleEmail, item]);
        }
    };

    const updatePassword = () => {
        const requestBody = {
            favorite: favourite,
            recordExtId: passwordRecordExtId,
            websiteUsername: passwordData.websiteUsername,
            websitePassword: passwordData.websitePassword,
            websiteUrl: passwordData.websiteUrl,
            websiteName: passwordData.websiteName,
            notes: passwordData.notes,
        };

        if (passwordData.websiteName && passwordData.websitePassword) {
            setLoading(true);
            window.toggle("ep-generate-confiq", "ep-generate-config-btn");
            setGeneratePasswordState({ ...generatePasswordState, isClosed: !generatePasswordState.isClosed });

            httpClient
                .sendRequest("POST", `api/securepassword/updatePassword`, requestBody)
                .then((data) => {
                    if (data.isSuccess) {
                        setLoading(false);
                        dispatch(PasswordManagerAction.actionCreators.setPasswordExtId(""));
                        Notification({
                            type: "success",
                            title: "Success",
                            message: "Password successfully updated.",
                            duration: 5,
                        });
                        closeDialog();
                        requestRequestPasswordList();
                    } else {
                        setLoading(false);
                        Notification({
                            type: "error",
                            title: "Error",
                            message: "Edit Password failed, please try again later.",
                            duration: 5,
                        });
                    }
                })
                .catch(function (error) {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: "Edit Password failed, please try again later.",
                        duration: 5,
                    });
                });
        }
    };

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const generatePasswordHandleChange = () => {
        if (generatePasswordState.isClosed) {
            window.toggle("ep-generate-confiq", "ep-generate-config-btn");
            setGeneratePasswordState({ ...generatePasswordState, isClosed: !generatePasswordState.isClosed });
        }

        generateNewPassword(parseInt(generatePasswordState.length), generatePasswordState.digits, generatePasswordState.symbols);
    };

    const handleChange = (event: any) => {
        const target = event.target;
        let value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        if (name === "notes" && value.length > 500) {
            value = value.slice(0, 500);
        }

        if (name === "websiteUrl" && value.length > 150) {
            value = value.slice(0, 150);
        }

        if (name === "websiteUsername" && value.length > 100) {
            value = value.slice(0, 100);
        }

        if (name === "websitePassword") {
            if (value.length > 64) {
                value = value.slice(0, 64);
            }

            updatePasswordStrength(value);
        }

        if (name === "websiteName") {
            if (value) {
                clearErrors("websiteName");
            }

            if (value.length > 64) {
                value = value.slice(0, 64);
            }
        }

        setPasswordData({
            ...passwordData,
            [name]: value,
        });

        if (!generatePasswordState.isClosed && name === "websitePassword") {
            setGeneratePasswordState({
                ...generatePasswordState,
                ["length"]: value.length,
            });
        }
    };

    const lengthChange = (event: any) => {
        const target = event.target;
        let value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        if (parseInt(value) > 64) {
            value = "64";
        }

        setGeneratePasswordState({
            ...generatePasswordState,
            [name]: value,
        });

        generateNewPassword(parseInt(value), generatePasswordState.digits, generatePasswordState.symbols);
    };

    const toggleSymbols = (event: any) => {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        setGeneratePasswordState({
            ...generatePasswordState,
            [name]: value,
        });

        generateNewPassword(parseInt(generatePasswordState.length), generatePasswordState.digits, value);
    };

    const generateNewPassword = (length: number, digits: boolean, symbols: boolean) => {
        window.addToDataLayer({ event: "Generate New Password" });
        const password = PasswordManagerUtil.passwordManagerUtilFunctions.generatePassword(length, digits, symbols);

        if (password) {
            clearErrors("websitePassword");
        }

        setPasswordData({ ...passwordData, websitePassword: password });
        updatePasswordStrength(password);
    };

    const toggleDigits = (event: any) => {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        setGeneratePasswordState({
            ...generatePasswordState,
            [name]: value,
        });
        generateNewPassword(parseInt(generatePasswordState.length), value, generatePasswordState.symbols);
    };

    

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="key" />
                </div>
                <h1>
                    {tLang("identityVault.passwordManager.addEditPassword.editPasswordTitle")} <span className="sr-only">{"for " + passwordData.websiteName}</span>
                </h1>
            </div>
            <form onSubmit={handleSubmit(submitUpdate)} id="edit-password-form-container">
                <div className={loading ? "dialog-body loading" : "dialog-body"}>
                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="ep-label-website-name">
                                {tLang("identityVault.passwordManager.addEditPassword.label.name")}{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                            <input
                                type="text"
                                className={submitted && !passwordData.websiteName ? "inputbox status-error" : "inputbox"}
                                id="ep-label-website-name"
                                maxLength={64}
                                placeholder=""
                                onChange={handleChange}
                                value={passwordData.websiteName ? passwordData.websiteName : ""}
                                name="websiteName"
                                aria-required="true"
                            />
                            {submitted && !passwordData.websiteName && (
                                <span id="error-ep-websiteName" className="form-error" aria-live="polite" aria-atomic="true">
                                    <p>{tLang("identityVault.passwordManager.validation.wbsiteNameRequired")}</p>
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="ep-label-username-email">{tLang("identityVault.passwordManager.addEditPassword.label.username")}</label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                            <input
                                type="text"
                                className="inputbox"
                                id="ep-label-username-email"
                                maxLength={100}
                                placeholder=""
                                onChange={handleChange}
                                name="websiteUsername"
                                defaultValue={passwordData.websiteUsername === "" ||
                                    visibleEmail.findIndex((element: any) => element.websiteUsername === passwordData.websiteUsername) >= 0
                                    ? passwordData.websiteUsername : Common.getUserNameOrMaskedEmail(passwordData.websiteUsername) }
                            />
                            
                            <div className="form-input-button">
                                {Common.checkIsEmail(passwordData.websiteUsername) && (
                                    <button
                                        type="button"
                                        className="btn-default btn-icon-only btn-no-padding"
                                        onClick={() => {
                                            toggleEmailVisibility(passwordData);
                                        }}
                                        title={
                                            visibleEmail.findIndex((element: any) => element.websiteUsername === passwordData.websiteUsername) < 0
                                                ? tLang("identityVault.monitoredInformation.businessInfoWidget.showEmailToolTip")
                                                : tLang("identityVault.monitoredInformation.businessInfoWidget.hideEmailToolTip")
                                        }
                                    >
                                        <span className="btn-icon">
                                            <em
                                                className={`las ${visibleEmail.findIndex((element: any) => element.websiteUsername === passwordData.websiteUsername) < 0 ? "la-eye" : "la-eye-slash"
                                                    }`}
                                            ></em>
                                        </span>
                                        <span className="btn-text">Show / Hide Email Text</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="ep-label-password">
                                {tLang("identityVault.passwordManager.addEditPassword.label.password")}{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs col-no-gutter form-input">
                                    <input
                                        type={passwordShown ? "text" : "password"}
                                        maxLength={64}
                                        className={submitted && !passwordData.websitePassword ? "inputbox status-error" : "inputbox"}
                                        id="ep-label-password"
                                        value={passwordData.websitePassword ? passwordData.websitePassword : ""}
                                        name="websitePassword"
                                        onChange={handleChange}
                                        placeholder=""
                                        aria-required="true"
                                    />
                                    {submitted && !passwordData.websitePassword && (
                                        <span id="error-ep-password" className="form-error" aria-live="polite" aria-atomic="true">
                                            <p>{tLang("identityVault.passwordManager.validation.passwordRequired")}</p>
                                        </span>
                                    )}
                                    <div className="form-input-button">
                                        <button
                                            type="button"
                                            className="btn-default btn-icon-only btn-no-padding"
                                            onClick={() => {
                                                setPasswordShown(!passwordShown);
                                                window.addToDataLayer({ event: "Show / Hide Password Text" });
                                            }}
                                            title={
                                                passwordShown
                                                    ? tLang("identityVault.passwordManager.addEditPassword.hidePwdAddPwdPopUp")
                                                    : tLang("identityVault.passwordManager.addEditPassword.shwPwdAddPwdPopUp")
                                            }
                                        >
                                            <span className="btn-icon">
                                                <em
                                                    className={`las ${passwordShown ? "la-eye-slash" : "la-eye"
                                                        }`}
                                                ></em>
                                            </span>
                                            <span className="btn-text">Show / Hide Password Text</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-xs flex-grow-null col-no-gutter">
                                    <button
                                        type="button"
                                        className="btn-default btn-primary-outline margin-left-xs"
                                        id="ep-generate-config-btn"
                                        onClick={generatePasswordHandleChange}
                                    >
                                        <span className="btn-toggle-status sr-only">Show</span>
                                        <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.generateBtnText")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="ep-generate-confiq" className="drawer-content" style={{ display: "none" }}>
                        <div className="row">
                            <div className="col-xs col-sm-8 col-sm-offset-4 col-no-gutter">
                                <div className="generate-confiq">
                                    <fieldset>
                                        <legend className="sr-only">Set Attributes for your generated password</legend>
                                        <div className={errors["length"] ? "form-row row status-error" : "form-row row"}>
                                            <div className="form-row inline row">
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="ep-label-pw-length">
                                                        {tLang("identityVault.passwordManager.addEditPassword.label.length")}
                                                    </label>
                                                </div>
                                                <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                    <input
                                                        type="number"
                                                        className="inputbox"
                                                        id="ep-label-pw-length"
                                                        placeholder=""
                                                        onChange={lengthChange}
                                                        name="length"
                                                        onInput={lengthChange}
                                                        value={generatePasswordState.length}
                                                        step="1"
                                                        size={4}
                                                        ref={register({
                                                            max: 64,
                                                            min: 1,
                                                        })}
                                                    />
                                                    {errors.length && errors.length.type === "max" && (
                                                        <span className="form-error">{tLang("identityVault.passwordManager.validation.paswordLength2")}</span>
                                                    )}

                                                    {errors.length && errors.length.type === "min" && (
                                                        <span className="form-error">{tLang("identityVault.passwordManager.validation.passwordLength")}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label">  <label className="form-toggle-label" htmlFor="ep-label-pw-digits">{tLang("identityVault.passwordManager.addEditPassword.label.digits")}</label></legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="form-row">
                                                        <div className="form-input">
                                                            <label className="form-toggle-label" htmlFor="ep-label-pw-digits">
                                                                <input
                                                                    type="checkbox"
                                                                    id="ep-label-pw-digits"
                                                                    checked={generatePasswordState.digits}
                                                                    name="digits"
                                                                    onChange={toggleDigits}
                                                                />
                                                                <span className="form-toggle-label-text">
                                                                    <span className="sr-only">Include Digits</span>
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset className="form-row no-margin inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label"> <label className="form-toggle-label" htmlFor="ep-label-pw-symbols">{tLang("identityVault.passwordManager.addEditPassword.label.symbols")}</label></legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="form-row">
                                                        <div className="form-input">
                                                            <label className="form-toggle-label" htmlFor="ep-label-pw-symbols">
                                                                <input
                                                                    type="checkbox"
                                                                    id="ep-label-pw-symbols"
                                                                    checked={generatePasswordState.symbols}
                                                                    name="symbols"
                                                                    onChange={toggleSymbols}
                                                                />
                                                                <span className="form-toggle-label-text">
                                                                    <span className="sr-only">Include Symbols</span>
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>

                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">{tLang("identityVault.passwordManager.addEditPassword.label.strength")}</legend>
                            </div>

                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <span id="ep-passwordmeter" className="passwordmeter">
                                    <span style={{ width: (strength.score + 1) * 25 + "px", backgroundColor: strength.color }}></span>
                                </span>
                                <span id="ep-passwordmessage" className="passwordmessage" aria-live="polite">
                                    <strong>{strength.message}</strong>
                                </span>
                            </div>
                        </div>
                    </fieldset>

                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="ep-label-website-url">{tLang("identityVault.passwordManager.addEditPassword.label.website")}</label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                            <input
                                type="text"
                                className="inputbox"
                                id="ep-label-website-url"
                                placeholder=""
                                maxLength={150}
                                value={passwordData.websiteUrl ? passwordData.websiteUrl : ""}
                                name="websiteUrl"
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="ep-label-notes">{tLang("identityVault.passwordManager.addEditPassword.label.notes")}</label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                            <textarea
                                className="inputbox"
                                value={passwordData.notes ? passwordData.notes : ""}
                                maxLength={500}
                                name="notes"
                                onChange={handleChange}
                                id="ep-label-notes"
                                placeholder={tLang("identityVault.passwordManager.placeholder.note")}
                                rows={6}
                            ></textarea>
                        </div>
                    </div>

                    <div className="form-row row">
                        <div className="col-xs-12 col-sm-offset-4 col-no-gutter">
                            <div className="form-input">
                                <label className="form-checkbox-label" htmlFor="ep-mark-password-favourite">
                                    <input
                                        type="checkbox"
                                        id="ep-mark-password-favourite"
                                        onChange={(e: any) => setFavourite(e.target.checked)}
                                        checked={favourite ? favourite : false}
                                    />
                                    <span className="form-checkbox-label-text">{tLang("identityVault.passwordManager.addEditPassword.label.mrkAsFvtTooltip")}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding btn-no-border"
                                onClick={() => {
                                    closeDialog();
                                    window.addToDataLayer({ event: "Cancel Editing Password" });
                                }}
                            >
                                <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.cancelBtnText")}</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <ul className="list-reset list-inline">
                                <li>
                                    <button
                                        type="button"
                                        className="btn-default btn-red-outline btn-no-border"
                                        data-a11y-dialog-show="dialog-delete-password"
                                        onClick={() => {
                                            props.showDeletePasswordDialog();
                                            window.addToDataLayer({ event: "Delete Password" });
                                        }}
                                    >
                                        <span className="btn-icon">
                                            <em className="las la-trash-alt"></em>
                                        </span>
                                        <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.deleteButtonText")}</span>
                                    </button>
                                </li>
                                <li className="margin-left-xs">
                                    <button
                                        type="submit"
                                        className="btn-default btn-primary btn-min-width"
                                        onClick={() => {
                                            setSubmitted(true);
                                            window.addToDataLayer({ event: "Update Password" });
                                        }}
                                    >
                                        <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.saveBtnText")}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
};

export default EditPassword;
